





















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import { isImageFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import config from "@/config";
import BaseSpinner from "@/components/BaseSpinner";

const ERROR_PLACEHOLDER = "/img/profile-placeholder.png";

export default defineComponent({
  name: "ProfileHeaderBackground",
  components: { BaseSpinner },
  props: {
    backgroundFile: { type: Object as () => FileData },
    progressPercent: { type: Number, default: 100 },
    user: { type: Object as PropType<UserPublicData | User | null> },
  },
  setup(props) {
    const isMember = computed(() => checkRole(props.user?.role || "", "member"));
    const isRestricted = computed<boolean>(() => config.featureRestrictMember && isMember.value);
    const isVideo = computed<boolean>(() => !!props.backgroundFile && isVideoFile(props.backgroundFile));
    const isReady = computed<boolean>(() => props.backgroundFile?.processingStatus === "OK");
    const isConverting = computed<boolean>(() => {
      return (
        props.backgroundFile?.processingStatus === "CONVERTING" || props.backgroundFile?.processingStatus === "NEW"
      );
    });
    const isError = computed<boolean>(() => props.backgroundFile?.processingStatus === "ERROR");
    const isLoaded = computed<boolean>(() => props.progressPercent !== 100);
    const showStatus = computed<boolean>(() => isConverting.value || isLoaded.value || isError.value);

    const url = computed<string>(() => {
      if (!props.backgroundFile) return "__empty";
      if (isError.value) return ERROR_PLACEHOLDER;

      const urlPart = props.backgroundFile.urlPart;
      if (isImageFile(props.backgroundFile)) return MediaFilesController.getImageThumbnail(urlPart, "1080p");
      if (!isReady.value && isVideo.value) return MediaFilesController.getVideoThumbnail(urlPart, "1080p");
      return "";
    });
    const videoSrc = computed<string>(() => {
      if (!props.backgroundFile || !isReady.value || !isVideo.value || url.value) return "";
      return MediaFilesController.getVideoUrl(props.backgroundFile?.urlPart);
    });

    return {
      isMember,
      isRestricted,
      url,
      isError,
      isLoaded,
      videoSrc,
      showStatus,
      isConverting,
      ERROR_PLACEHOLDER,
    };
  },
});
